import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { useIntl } from 'react-intl';
import messages from './messages';
import schema from './schema';
import View from './View';
import BlockImageInput from '../../helpers/BlockImageInput/BlockImageInput';

const Edit = (props: any) => {
  const intl = useIntl();
  const {
    onChangeBlock,
    data,
    block,
    selected,
    navRoot,
    contentType,
    blocksErrors,
  } = props;
  const blockSchema = schema({ ...props, intl });

  const imageSlot = ({ fieldId, index, value, element }: any) => {
    if (fieldId !== 'subcategories' || typeof index !== 'number')
      return undefined;
    return (
      <BlockImageInput
        id={`subcategories-${index}-image`}
        block={block}
        value={value}
        imageSize="large"
        variant="strip"
        description={intl.formatMessage(messages.image)}
        onChange={(next) => {
          const subcategories = [...(data.subcategories || [])];
          subcategories[index] = { ...subcategories[index], image: next };
          onChangeBlock(block, { ...data, subcategories });
        }}
      >
        {element}
      </BlockImageInput>
    );
  };

  return (
    <>
      <View {...props} isEditMode imageSlot={imageSlot} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={blockSchema}
          title={blockSchema.title}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          navRoot={navRoot}
          contentType={contentType}
          errors={blocksErrors}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
